export const MIN_SLOT = 0;
export const MAX_SLOT = 7140;
export const PROBABILITY_MIN_SLOT = 6000;
export const PROBABILITY_MAX_SLOT = 7100;
export const BEST_SLOT = 6500;
export const SLOT_DURATION = 180000;
// 60 seconds = 60000 ms
export const FETCH_DATA_INTERVAL = 60 * 1000;
